import React, { useState } from "react";

import {
	IProcurementSupplierNextStatus,
	ProcurementHeaderViewOrderResponse,
	ManageStatusItemsResponse,
	ProcurementSupplierItem,
	QuoteDataResponse,
} from "@/main/models/response";

import { IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Info from "@mui/icons-material/Info";
import FavoriteButton from "../favoriteButton/favoriteButton";
import SummaryCost from "../summaryCost/summaryCost";
import RowPart from "./rowPart/rowPart";
import * as S from "./styles";
import { procurementApi } from "@/main/api";
import { IHandleSetInfo } from "@/main/screens/order/viewOrder/components/cardGrid/cardGrid";
import { IMAGE_DEFAULT } from "@/main/services/constants";
import { userIsAdmin, userIsBuyer, userIsSupplier } from "@/main/services/utilsUser";
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from "@/main/services/utils";
import { Controls } from "@/main/services/constants/constantsControl";
import ColumnLabel from "../../common/columnLabel/columnLabel";
import ButtonStatus from "./buttonStatus/buttonStatus";
import { InitialStateEditPart } from "@/main/screens/order/viewOrder/components/infoOrder/infoOrder";
import ModalContacts from "@/main/components/shared/modalContacts/modalContacts";
import TooltipComponent from "../tooltip/tooltipComponent";
import WhatsappLink from "../whatsappLink/whatsappLink";
import StarRatingPartially from "../starRating/starRatingPartially";
import { EvaluationSupplierEnum } from "@/main/services/enum/EvaluationSupplierEnum";
import { SupplierEvaluationSaved } from "@/main/models/response/evaluationSupplierResponse";

interface ICardSupplierProps {
	guidSupplier?: string;
	guidCompanySupplier?: string;
	guidCompany: string;
	supplierName: string;
	isFavoriteProp: boolean;
	deliveryBySupplier: boolean;
	shippingCost?: number;
	itemTotalCost?: number;
	supplierItems: ProcurementSupplierItem[];
	guidProcurementSupplier: string;
	procurementSupplierNextStatus?: IProcurementSupplierNextStatus[];
	guidQuote: string;
	handleOpenInfoSide?: (
		guidSupplier: string,
		deliveryBySupplier: boolean,
		statusSupplier: number,
		open: boolean,
		guidProcurementSupplier: string,
		guidProcurementStatusCompany: string,
		idProcurementStatusCompany: number,
	) => void;
	displayPartsDetails: (supplierInventoryGuid: string, guidQuoteSupplierItem: string) => void;
	displayImagesReturnModal: (guidProcurementSupplierItem: string) => void;
	handleSetInfoReason?: (propReason: IHandleSetInfo) => void;
	handleOpenConfirmProcess?: (propConfirmProcess: IHandleSetInfo) => void;
	guidQuoteProcurement: string;
	contactName: string;
	contactEmail: string;
	contactPhone: string;
	setEditPart: React.Dispatch<React.SetStateAction<InitialStateEditPart>>;
	isManagePackages?: boolean;
	showPrices: boolean;
	rowGrid: QuoteDataResponse;
	contactNumberIsWhatsapp?: boolean;
	scoreSupplier?: number;
	evaluationSupplierEnum?: number;
	guidEvaluationCompanyBuyer?: string;
	supplierEvaluationSaved?: SupplierEvaluationSaved[];
	dataHeader: ProcurementHeaderViewOrderResponse | null;
	viewEvaluationSupplierApi?: (guidEvaluationCompanyBuyerValue: string) => void;
	evaluateSupplierApi?: (guidSupplier: string, supplierName: string) => void;
	handleUpdateQuoteCountStatus?: () => void;
	handleUpdateQuoteGridStatus?: (guid: string, newStatus: number, newStatusSupplierName: string) => void;
	setResultDataManageStatus?: (data: ManageStatusItemsResponse | null) => void;
	loadViewOrder?: (guidQuoteProcurement: string) => void;
}

const useStylesTooltip = makeStyles({
	popperCustom: { marginLeft: 15 },
});

interface IContactsSupplierProps {
	contactName: string;
	contactPhone: string;
	contactEmail: string;
	rowGrid: QuoteDataResponse;
	supplierName: string;
	showInMobile?: boolean;
	contactNumberIsWhatsapp?: boolean;
	guidCompanySupplier?: string;
}
const ContactsSupplier = ({
	contactNumberIsWhatsapp,
	contactName,
	contactPhone,
	contactEmail,
	rowGrid,
	supplierName,
	showInMobile = false,
	guidCompanySupplier,
}: IContactsSupplierProps) => {
	const classesTooltip = useStylesTooltip();
	const [showContactModal, setShowContactModal] = useState(false);

	function handleShowContactModal(open: boolean) {
		setShowContactModal(open);
	}

	const showTooltipModalContacts = !userIsSupplier() && guidCompanySupplier;
	return (
		<>
			<S.AreaContactSupplier $showInMobile={showInMobile}>
				{contactName && (
					<ColumnLabel
						label={getTranslateByKey("information.contactName")}
						content={<S.TextCollumnLabel title={contactName}>{contactName}</S.TextCollumnLabel>}
					/>
				)}
				{contactPhone && (
					<ColumnLabel
						label={getTranslateByKey("information.contactPhoneSupplier")}
						content={
							<WhatsappLink
								isWhatsapp={contactNumberIsWhatsapp}
								phone={contactPhone}
								claimNumber={String(rowGrid.claimNumber)}
								companyName={supplierName}
								orderNumber={String(rowGrid.claimNumber)}
								vehicleName={rowGrid.vehicle}
								insurerName={rowGrid.insurerCompanyName}
							/>
						}
					/>
				)}
				{contactEmail && (
					<ColumnLabel
						label={getTranslateByKey("information.contactEmail")}
						content={
							<S.AreaEmail>
								<S.TextCollumnLabel title={contactEmail}>{contactEmail}</S.TextCollumnLabel>
								{showTooltipModalContacts && (
									<TooltipComponent
										title={getTranslateByKey("information.viewContacts")}
										placement="top"
										stylePopper={classesTooltip.popperCustom}
									>
										<span>
											<IconButton
												size="medium"
												color="primary"
												style={{ marginLeft: 5 }}
												onClick={() => handleShowContactModal(true)}
												id="id-contactModal-btn-seeContactModal"
											>
												<Info />
											</IconButton>
										</span>
									</TooltipComponent>
								)}
							</S.AreaEmail>
						}
					/>
				)}
			</S.AreaContactSupplier>
			{showTooltipModalContacts && (
				<ModalContacts
					guidCompany={guidCompanySupplier}
					open={showContactModal}
					closeModal={() => handleShowContactModal(false)}
					infoProcurement={{
						claimNumber: String(rowGrid?.claimNumber),
						insurerName: rowGrid?.insurerCompanyName,
						companyName: supplierName,
						orderNumber: rowGrid?.orderNumber,
						vehicleName: rowGrid?.vehicle,
					}}
				/>
			)}
		</>
	);
};
function CardSupplier({
	showPrices,
	guidSupplier,
	guidCompany,
	guidCompanySupplier,
	supplierName,
	isFavoriteProp,
	deliveryBySupplier,
	shippingCost,
	itemTotalCost,
	supplierItems,
	guidProcurementSupplier,
	procurementSupplierNextStatus,
	guidQuote,
	rowGrid,
	handleOpenInfoSide,
	displayPartsDetails,
	displayImagesReturnModal,
	handleSetInfoReason,
	handleOpenConfirmProcess,
	guidQuoteProcurement,
	contactName,
	contactEmail,
	contactPhone,
	setEditPart,
	isManagePackages = false,
	contactNumberIsWhatsapp,
	scoreSupplier,
	evaluationSupplierEnum,
	guidEvaluationCompanyBuyer,
	supplierEvaluationSaved,
	dataHeader,
	viewEvaluationSupplierApi,
	evaluateSupplierApi,
	handleUpdateQuoteCountStatus = () => {},
	handleUpdateQuoteGridStatus = () => {},
	setResultDataManageStatus = () => {},
	loadViewOrder = () => {},
}: ICardSupplierProps) {
	const [isFavorite, setIsFavorite] = useState(isFavoriteProp);

	const isBuyer = userIsBuyer(guidCompany);

	const isAdmin = userIsAdmin();
	const isUserSupplier = userIsSupplier();
	const showEvaluateSupplierSearchOrders = isShowControlByElementId(Controls.IdEvaluateSupplierSearchOrders);

	// Handle functions
	async function toggleFavorite() {
		if (isAdmin || isBuyer) {
			return;
		}

		try {
			setIsFavorite((prev) => !prev);
			await procurementApi.saveFavorite({
				guidSupplier: guidSupplier,
				guidCompany: guidCompany,
				favorite: !isFavorite,
			});
		} catch {}
	}

	//  Render functions
	function shouldRenderLinkForEvaluate() {
		if (!isNullUndefined(evaluationSupplierEnum) && evaluationSupplierEnum !== EvaluationSupplierEnum.NotAvailable) {
			if ((isBuyer || isUserSupplier || isAdmin) && showEvaluateSupplierSearchOrders) {
				return true;
			}
		}

		return false;
	}

	function renderLinkViewEvaluation(guidEvaluationCompanyBuyerParam: string) {
		return (
			<S.LinkEvaluate
				onClick={() => {
					if (!isNullUndefined(viewEvaluationSupplierApi)) {
						viewEvaluationSupplierApi(String(guidEvaluationCompanyBuyerParam));
					}
				}}
			>
				{getTranslateByKey("information.viewEvaluation")}
			</S.LinkEvaluate>
		);
	}

	function renderLinkForEvaluate() {
		if (shouldRenderLinkForEvaluate()) {
			if (
				!isNullUndefined(guidEvaluationCompanyBuyer) ||
				(!isNullUndefined(evaluationSupplierEnum) && evaluationSupplierEnum === EvaluationSupplierEnum.Evaluated)
			) {
				return renderLinkViewEvaluation(String(guidEvaluationCompanyBuyer));
			}

			if (
				!isNullUndefined(supplierEvaluationSaved) &&
				supplierEvaluationSaved.length > 0 &&
				!isNullUndefined(guidSupplier)
			) {
				const evaluation = supplierEvaluationSaved.find(
					(x: SupplierEvaluationSaved) => x.guidSupplier.toLowerCase() === guidSupplier.toLowerCase(),
				);

				if (evaluation) {
					return renderLinkViewEvaluation(evaluation.guidEvaluationCompanyBuyer);
				}
			}

			if (
				isNullUndefined(guidEvaluationCompanyBuyer) ||
				(!isNullUndefined(evaluationSupplierEnum) && evaluationSupplierEnum === EvaluationSupplierEnum.ToEvaluate)
			) {
				if (!isUserSupplier) {
					return (
						<S.LinkEvaluate
							onClick={() => {
								if (!isNullUndefined(evaluateSupplierApi)) {
									evaluateSupplierApi(String(guidSupplier), supplierName);
								}
							}}
						>
							{getTranslateByKey("information.evaluateTheSupplier")}
						</S.LinkEvaluate>
					);
				}
			}
		}

		return <></>;
	}

	const showButtonsHeader =
		procurementSupplierNextStatus &&
		procurementSupplierNextStatus.length > 0 &&
		isShowControlByElementId(Controls.IdChangeStatus);

	const propsContactSupplier: IContactsSupplierProps = {
		contactEmail,
		contactName,
		contactNumberIsWhatsapp,
		contactPhone,
		guidCompanySupplier,
		rowGrid,
		supplierName,
	};

	return (
		<S.Container>
			<S.Header>
				<S.SupplierName title={supplierName}>{supplierName}</S.SupplierName>
				{showButtonsHeader &&
					procurementSupplierNextStatus.map((option) => (
						<ButtonStatus
							key={option.guidProcurementStatusCompany}
							guidProcurementSupplier={guidProcurementSupplier}
							procurementSupplierNextStatus={option}
							guidSupplier={String(guidSupplier)}
							deliveryBySupplier={deliveryBySupplier}
							handleOpenInfoSide={handleOpenInfoSide}
						/>
					))}
				{!isManagePackages && (
					<S.AreaInfoHeader>
						<FavoriteButton
							id="id-searchOrder-button-favorite"
							isFavorite={isFavorite}
							onToggleFavorite={() => toggleFavorite()}
							notClickable={isAdmin || isBuyer}
						/>
						<S.ContainerRightHeader>
							<ContactsSupplier {...propsContactSupplier} />
							<S.ContainerEvaluate>
								{renderLinkForEvaluate()}
								<StarRatingPartially rating={!isNullUndefined(scoreSupplier) ? scoreSupplier : 0} />
							</S.ContainerEvaluate>
						</S.ContainerRightHeader>
					</S.AreaInfoHeader>
				)}
			</S.Header>
			<S.AreaInfoContactSupplierMobile>
				<ContactsSupplier {...propsContactSupplier} showInMobile />
			</S.AreaInfoContactSupplierMobile>
			<S.Content>
				{supplierItems.map((item) => (
					<RowPart
						key={item.guidSupplierItem}
						image={item.image1 || IMAGE_DEFAULT}
						procurementSupplierItem={item}
						dataHeader={dataHeader}
						deliveryBySupplier={deliveryBySupplier}
						guidProcurementSupplier={guidProcurementSupplier}
						guidQuoteProcurement={guidQuoteProcurement}
						supplierItems={supplierItems}
						guidQuote={guidQuote}
						guidCompany={guidCompany}
						isManagePackages={isManagePackages}
						showPrices={showPrices}
						handleOpenConfirmProcess={handleOpenConfirmProcess}
						displayPartsDetails={displayPartsDetails}
						displayImagesReturnModal={displayImagesReturnModal}
						handleSetInfoReason={handleSetInfoReason}
						handleUpdateQuoteCountStatus={handleUpdateQuoteCountStatus}
						handleUpdateQuoteGridStatus={handleUpdateQuoteGridStatus}
						setResultDataManageStatus={setResultDataManageStatus}
						loadViewOrder={loadViewOrder}
						setEditPart={setEditPart}
					/>
				))}
			</S.Content>
			<S.Footer>
				<SummaryCost
					showPrices={showPrices}
					shippingCost={shippingCost}
					total={itemTotalCost}
					deliveryBySupplier={deliveryBySupplier}
				/>
			</S.Footer>
		</S.Container>
	);
}

export default CardSupplier;
